export default "__VITE_PUBLIC_ASSET__11644e35__"